export class Api {
    constructor(){

    }
    protected readonly URL = 'https://customer.api.cw.marketing'
    protected readonly URL_ADMIN = 'https://admin.api.cw.marketing'
}